import icon from "../../assets/dots.svg";
import type { Property } from "../../types";

export const pinAccess: Property = {
  id: "pinAccess",
  title: "pinAccess.title",
  icon,
};
